/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Filter_Option_CountInputs */

const th_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const en_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const ja_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}（${i?.count}件）`)
};

const zh_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}（${i?.count}）`)
};

const es_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const pt_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const id_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const fr_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const tl_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const vi_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const ko_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const de_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const ru_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const tr_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const it_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const pl_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const uk_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const hi_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const ar_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const ms_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const bn_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const zh_tw2_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}（${i?.count}）`)
};

const zh_hk2_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}（${i?.count}）`)
};

const ur_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const fa_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const sw_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

const nl_filter_option_count = /** @type {(inputs: Filter_Option_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count})`)
};

/**
* | output |
* | --- |
* | "{name} ({count})" |
*
* @param {Filter_Option_CountInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const filter_option_count = /** @type {((inputs: Filter_Option_CountInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Option_CountInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_filter_option_count(inputs)
	if (locale === "ja") return ja_filter_option_count(inputs)
	if (locale === "zh") return zh_filter_option_count(inputs)
	if (locale === "es") return es_filter_option_count(inputs)
	if (locale === "pt") return pt_filter_option_count(inputs)
	if (locale === "id") return id_filter_option_count(inputs)
	if (locale === "fr") return fr_filter_option_count(inputs)
	if (locale === "tl") return tl_filter_option_count(inputs)
	if (locale === "vi") return vi_filter_option_count(inputs)
	if (locale === "ko") return ko_filter_option_count(inputs)
	if (locale === "de") return de_filter_option_count(inputs)
	if (locale === "ru") return ru_filter_option_count(inputs)
	if (locale === "tr") return tr_filter_option_count(inputs)
	if (locale === "it") return it_filter_option_count(inputs)
	if (locale === "pl") return pl_filter_option_count(inputs)
	if (locale === "uk") return uk_filter_option_count(inputs)
	if (locale === "hi") return hi_filter_option_count(inputs)
	if (locale === "ar") return ar_filter_option_count(inputs)
	if (locale === "ms") return ms_filter_option_count(inputs)
	if (locale === "bn") return bn_filter_option_count(inputs)
	if (locale === "zh-TW") return zh_tw2_filter_option_count(inputs)
	if (locale === "zh-HK") return zh_hk2_filter_option_count(inputs)
	if (locale === "ur") return ur_filter_option_count(inputs)
	if (locale === "fa") return fa_filter_option_count(inputs)
	if (locale === "sw") return sw_filter_option_count(inputs)
	if (locale === "nl") return nl_filter_option_count(inputs)
	return en_filter_option_count(inputs)
});